<style lang="less">
    .up_img{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        .meng{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba(51, 51, 51, 0.51);
        }
        .upImgBox{
            min-height: 240px;
            max-width: 420px;
            padding-top: 10px;
            position: relative;
            // left: 50%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 2;
            margin: 0 auto;
            background-color: #fff;
            border-radius: 8px;
            >div{
                display: flex;
                // justify-content: space-between;
                flex-wrap: wrap;
                // min-width: 280px;
                // max-width: 600px;
                padding: 0 10px;
                >div{
                    border: 1px solid #ccc;
                    width: 120px;
                    height: 120px;
                    // margin: 20px auto;
                    position: relative;
                    margin: 0 20px 20px 0;
                    &:nth-of-type(3n){
                        margin: 0 0px 20px 0;
                    }
                    >img{
                        width: 100%;
                        height: 100%;
                    }
                    >div{
                        cursor: pointer;
                        position: absolute;
                        right: 3px;
                        top: 3px;
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        background: rgba(117, 117, 117,0.6);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 18px;
                            height: 18px;
                        }
                    }
                }
                
            }
            .upImgFoot{
                padding: 10px 20px;
                display: flex;
                width: 100%;
                position: absolute;
                justify-content: space-between;
                bottom: 0;
                left: 0;
                border: none;
                li{
                    list-style: none;
                }
                .upImgBtn{
                    
                    >span{
                        display: inline-block;
                        width: 86px;
                        text-align: center;
                        border-radius: 8px;
                        border: 1px solid #dedede;
                        height: 24px;
                        line-height: 24px;
                    }
                    input{
                        position: relative;
                            left: -90px;
                            opacity: 0;
                            width: 86px
                    }
                }
            }
            
        }
    }
</style>
<template>
    <div class="up_img">
        <div class="meng" @click="hideUpImg"></div>
        <div class="upImgBox">
            <div>
                <div v-for="(item,index) in nowPictures" :key="index">
                    <img :src="item.url" alt="">
                    <div @click="deletImg(index)"><img src="../../../../assets/icon_chacha_n.png" alt=""></div>
                </div>
            </div>
            <p style="height:50px;"></p>
            <ul class="upImgFoot">
                <li class="upImgBtn">
                    <span><i class="el-icon-plus"></i>添加图片</span>
                    <input @change="UpImg" type="file" accept="image/*">
                </li>
                <!-- <li><el-button>确认</el-button></li> -->
            </ul>
            
        </div>
    </div>
</template>
<script>
import  upload  from '../../../../util/uploadOss'
export default {
    data(){
        return{
            imgUrl:'',
            change:false,
            nowPictures:[]
        }
    },
    props:['clickRowId','pictures'],
    methods:{
        hideUpImg(){

          if(this.change){
            this.$emit('hideUpImg',this.nowPictures,this.clickRowId)
          }else{
            this.$emit('hideUpImg','',this.clickRowId)
          }

        },
        UpImg(e){
            let file = e.target.files[0]
            upload.uploadVideoToOss(file,res=>{
                let img = {
                    name:'1',
                    url:res
                }
                this.nowPictures.push(img)
                this.change=true
            },()=>{})
        },
        deletImg(index){
            if(this.nowPictures.length == 1){
                this.$message('至少保留一张商品图片')
                return
            }
            this.nowPictures.splice(index,1)
            this.change=true
        }
    },
    mounted(){
        this.nowPictures = this.pictures
    }
}
</script>
